import { createAuth } from "@websanova/vue-auth/src/v3.js";
import driverAuthBearer from "@websanova/vue-auth/src/drivers/auth/bearer.js";
import driverHttpAxios from "@websanova/vue-auth/src/drivers/http/axios.1.x.js";
import driverRouterVueRouter from "@websanova/vue-auth/src/drivers/router/vue-router.2.x.js";
import { useAuthStore } from "@/stores";

export default (app) => {
  const authStore = useAuthStore();

  app.use(
    createAuth({
      plugins: {
        http: app.axios,
        router: app.router,
      },
      drivers: {
        http: driverHttpAxios,
        auth: driverAuthBearer,
        router: driverRouterVueRouter,
      },
      options: {
        staySignedIn: false,
        rolesKey: "type",
        tokenStore: ["localStorage", "cookie"],
        loginData: {
          url: "/auth/login",
          method: "POST",
          redirect: "/home",
          headerToken: "Authorization",
          fetchUser: true,
          customToken: (response) => response.data.access_token,
        },
        fetchData: {
          url: "/api/auth/user",
          method: "get",
          interval: 10,
          enabled: true,
        },
        logoutData: {
          url: "/api/auth/logout",
          method: "POST",
          redirect: "/logout",
        },
        parseUserData(data) {
          authStore.$patch({
            user: data,
          });

          if (data.dealer && data.dealer.domain) {
            authStore.setDealer(data.dealer.domain);

            /**
             * If the user has a company subdomain but is on the root domain,
             * redirect them to the correct subdomain.  Skip this check when
             * the login page is handling the redirect itself, or when the user
             * is actively impersonating another user.
             */
            const currentSubdomain = window.location.hostname.split('.')[0];
            const isLoginPage = window.location.pathname.startsWith('/login');
            const isImpersonating = !!localStorage.getItem('impersonate_user');
            if (currentSubdomain !== data.dealer.domain && !isLoginPage && !isImpersonating) {
              window.location.href = `${window.location.protocol}//${data.dealer.domain}.ep-training.com${window.location.pathname}${window.location.search}`;
            }
          }

          return data;
        },
      },
    })
  );
};
